import { GameTextUtil } from "@lib/js-slingo-fruttiboost-core/dist/game/utils/GameTextUtil";
import { GameBigWinProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameBigWinProperties";
import { Point } from "pixi.js";
export class BigWinPortraitProperties extends GameBigWinProperties {
    constructor() {
        super();
        this.position.set(512, 973);
        const texts = [this.title0Properties, this.title1Properties, this.title2Properties, this.title3Properties].map(x => x.text);
        texts.forEach(x => {
            x.size = new Point(800, 600);
            x.fontProperties.setLineHeight(200);
            x.multiline = true;
        });
        GameTextUtil.centerProperties(...texts);
    }
}
//# sourceMappingURL=BigWinPortraitProperties.js.map